const Footer = () => (
  <cr-global-footer
    simple='true'
    showMarquee='true'
    showTrustPilot='true' // to display the trust pilot widget
    showStarlightBanner='true' // to display the starlight banner
    showBorderTop='true' // This will work only if you're logged in
    isMarketing='true' // If its marketing page then set it to true
    theme='purple' // If its marketing page then set it to purple
    showFeatured='true'
    showStickyBanner={true}
  ></cr-global-footer>
);

export default Footer;

// If your page is a marketing page use this config

// export const DEFAULT_MARKETING_FOOTER_CONFIG = {
//   theme: 'purple',
//   showFeatured: true,
//   showMarquee: true,
//   showBorderTop: false,
//   showTrustPilot: true,
//   showStarlightBanner: true,
//   isMarketing: true,
// };

// If your page is a product page use this config
// export const DEFAULT_PRODUCT_FOOTER_CONFIG = {
//   theme: 'white',
//   showFeatured: true,
//   showMarquee: false,
//   showBorderTop: true,
//   showTrustPilot: true,
//   showStarlightBanner: true,
//   isMarketing: false,
// };
